import { useState } from 'react';
import { Clock, ChevronDown, ChevronUp } from 'lucide-react';
import HistoryTab from '../HistoryTab/HistoryTab';
import styles from './HistoryAccordion.module.css';

export default function HistoryAccordion({ entityPath }) {
  const [isOpen, setIsOpen] = useState(false);
  const [hasOpened, setHasOpened] = useState(false);

  function handleToggle() {
    if (!isOpen && !hasOpened) {
      setHasOpened(true);
    }
    setIsOpen((prev) => !prev);
  }

  return (
    <div className={styles.accordion}>
      <button
        type="button"
        className={styles.header}
        onClick={handleToggle}
        aria-expanded={isOpen}
      >
        <Clock size={14} strokeWidth={1.5} className={styles.clockIcon} />
        <span className={styles.label}>History</span>
        <span className={styles.chevron}>
          {isOpen
            ? <ChevronUp size={14} strokeWidth={1.5} />
            : <ChevronDown size={14} strokeWidth={1.5} />
          }
        </span>
      </button>
      <div className={isOpen ? styles.bodyOpen : styles.bodyClosed}>
        {hasOpened && <HistoryTab entityPath={entityPath} />}
      </div>
    </div>
  );
}
